import {Injectable, Type} from "@angular/core";
import {HeroComponent} from "./hero/hero.component";
import {CheckerboardComponent} from "./checkerboard/checkerboard.component";
import {GalleryComponent} from "./gallery/gallery.component";
import {ShareLinkComponent} from "./share-link/share-link.component";
import {PageNotFoundComponent} from "./page-not-found/page-not-found.component";
import {VideoComponent} from "./video/video.component";
import {FaqComponent} from "./faq/faq.component";
import {DuoToneComponent} from "./duo-tone/duo-tone.component";
import {HorizontalCardComponent} from "./horizontal-card/horizontal-card.component";
import {GalleryCardsComponent} from "./gallery-cards/gallery-cards.component";
import {NavCategoryComponent} from "./placeholder/nav-category/nav-category.component";
import {LandingAdHeroComponent} from "./placeholder/landing-ad-hero/landing-ad-hero.component";
import {LandingAdSideBySideComponent} from "./placeholder/landing-ad-side-by-side/landing-ad-side-by-side.component";
import {
    FeaturedProductsRowGuidedComponent
} from "./placeholder/featured-products-row-guided/featured-products-row-guided.component";
import {FeaturedProductsRowComponent} from "./placeholder/featured-products-row/featured-products-row.component";
import {LandingAdHeroGuidedComponent} from "./placeholder/landing-ad-hero-guided/landing-ad-hero-guided.component";

@Injectable({
    providedIn: "root"
})
export class MarketingPageFactoryService {

    heroComponent: Type<HeroComponent> = HeroComponent;
    checkerboardComponent: Type<CheckerboardComponent> = CheckerboardComponent;
    galleryComponent: Type<GalleryComponent> = GalleryComponent;
    shareLinkComponent: Type<ShareLinkComponent> = ShareLinkComponent;
    pageNotFoundComponent: Type<PageNotFoundComponent> = PageNotFoundComponent;
    videoComponent: Type<VideoComponent> = VideoComponent;
    faqComponent: Type<FaqComponent> = FaqComponent;
    duoToneComponent: Type<DuoToneComponent> = DuoToneComponent;
    horizontalCardComponent: Type<HorizontalCardComponent> = HorizontalCardComponent;
    galleryCardsComponent: Type<GalleryCardsComponent> = GalleryCardsComponent;
    navCategoryComponent: Type<NavCategoryComponent> = NavCategoryComponent;
    featuredProductsRowComponent: Type<FeaturedProductsRowComponent> = FeaturedProductsRowComponent;
    featuredProductsRowGuidedComponent: Type<FeaturedProductsRowGuidedComponent> = FeaturedProductsRowGuidedComponent;
    landingAdHeroComponent: Type<LandingAdHeroComponent> = LandingAdHeroComponent;
    landingAdGuidedComponent: Type<LandingAdHeroGuidedComponent> = LandingAdHeroGuidedComponent;
    landingAdSideBySideComponent: Type<LandingAdSideBySideComponent> = LandingAdSideBySideComponent;
}
